import { AUTOMATION_CREATION_STEPS, RECOGNITION_STATUSES } from '@hero/constants';

import { DraftCostSummary } from './DraftCostSummary';
import { LiveCostSummary } from './LiveCostSummary';

const draftStatuses = [
  RECOGNITION_STATUSES.draft,
  RECOGNITION_STATUSES.pending_approval,
  RECOGNITION_STATUSES.approved,
  AUTOMATION_CREATION_STEPS.draft
];

const CostSummary = props => {
  const isDraftFeature = draftStatuses.includes(props.status);

  if (!props.status) {
    return null; // maybe we can add a loader
  }

  if (isDraftFeature) {
    return <DraftCostSummary {...props} />;
  }

  return <LiveCostSummary {...props} />;
};

export { CostSummary };
